import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18NConsumer, I18N, NotFound, Loading } from 'commons';
import { orgId, Ajax, setPageTitle } from 'utils';

export default function FAQs(props) {
  const { orgName } = props;
  const [content, setContent] = useState('');
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const url = `/${orgId}/faqs`;
    Ajax.get(url).then(({ data }) => {
      setLoading(false);
      if (data?.faqs === null) {
        setContent(null);
      } else {
        setContent(data.faqs.pageContent);
      }
    });
  }, []);

  if (isLoading === true) {
    return <Loading />;
  }
  
  if (content === null) {
    return <NotFound orgName={orgName} />;
  }

  return (
    <div className="well ssp-well container col-11">
      <I18NConsumer>
        {(i18n) => setPageTitle(`${orgName} - ${i18n['ssp.main.lable.faqs']}`)}
      </I18NConsumer>
      <div className="offset-md-1 col-md-10">
        <h1 className="h1">
          <I18N>ssp.main.lable.faqs</I18N>
        </h1>
        <div className="faqs-container " dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
}

FAQs.propTypes = {
  orgName: PropTypes.string.isRequired
};
